<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="4" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="4" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_imo" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">IMO</label>
                        </div>
                    </b-col>
                    <b-col sm="4" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_irin" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">IRIN</label>
                        </div>
                    </b-col>
                    <b-col sm="4" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_erp" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">ERP</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="nomeembarcacao"
                        :options="optionsNomeEmbarcacao"
                        track-by="value"
                        label="label"
                        :option-height="25"
                        :hide-selected="true"
                        placeholder="Nome da Embarcação"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_propriedade"
                        :options="optionsTipoPropriedade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo de Propriedade"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_embarcacao"
                        :options="optionsTipoEmbarcacao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo de Embarcacao"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      cd: '',
      cd_imo: '',
      cd_irin: '',
      cd_erp: '',
      optionsNomeEmbarcacao: [],
      nomeembarcacao: [],
      optionsTipoPropriedade: [],
      tp_propriedade: [],
      optionsTipoEmbarcacao: [],
      tp_embarcacao: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              nomeembarcacao: this.nomeembarcacao,
                              cd_irin: this.cd_irin,
                              cd_erp: this.cd_erp,
                              tp_propriedade: this.tp_propriedade,
                              tp_embarcacao: this.tp_embarcacao,
                              cd_imo: this.cd_imo};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.cd_imo = '';
        this.cd_irin = '';
        this.cd_erp = '';
        this.tp_propriedade = '';
        this.tp_embarcacao = '';
        this.nomeembarcacao = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral()
      {
          this.helpForm.get('/api/embarcacao/jsonlistgeralfiltros').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.embarcacao.forEach((obj)=>
              {
                  this.optionsNomeEmbarcacao.push({ label: obj.nome, value: obj.embarcacao_id })
              })
              response.tp_propriedade.forEach((obj)=>
              {
                  this.optionsTipoPropriedade.push({ label: obj.descr, value: obj.valor })
              })
              response.param_tipo_embarcacao.forEach((obj)=>
              {
                  this.optionsTipoEmbarcacao.push({ label: obj.descr, value: obj.partpemb_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
    computed: {
        vuetableFilterButton: {
            get () {
                return this.$store.state.vuetable.filterButton;
            },
        },
    }
}
</script>
